import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { EngineComponent } from "./components/engine/engine.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";

const routes: Routes = [
  { path: "", component: EngineComponent },
  // { path: ":client/:sceneId", component: EngineComponent },
  // { path: ":client", component: EngineComponent },
  { path: "not-found", component: NotFoundComponent },
  // { path: "**", pathMatch: "full", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
